<template>
  <div class="notice_mng">
    <div class="title-tabs">
      <h2
        class="tabs-item"
        :class="index == tabsActive ? 'tabs-item-activity' : ''"
        v-for="(item, index) in tabsList"
        :key="index"
        @click="tabsChange(index)"
      >
        {{ item }}
      </h2>
    </div>
    <section class="pd2430" v-if="show">
      <el-tabs v-model="elTabsActive">
        <el-tab-pane label="购买保险" name="1">
          <Insure
            :getApiList="insure.getApiList"
            :getApiExport="insure.getApiExport"
            :postApiBuy="insure.postApiBuy"
            :roleType="tabsActive"
          ></Insure>
        </el-tab-pane>
        <el-tab-pane label="购买历史" name="2">
          <InsureHistory
            :getApiList="insureHistory.getApiList"
            :getApiExport="insureHistory.getApiExport"
            :roleType="tabsActive"
          ></InsureHistory>
        </el-tab-pane>
      </el-tabs>
    </section>
  </div>
</template>

<script>
import {
  getApiInsureList,
  getApiInsureHistoryList,
  getApiInsureExport,
  getApiInsureHistoryExport,
  postApiInsure,
  getApiHeadmasterInsureList,
  getApiHeadmasterInsureHistoryList,
  getApiHeadmasterInsureExport,
  getApiHeadmasterInsureHistoryExport,
  postApiHeadmasterInsure,
  getApiExpertInsureList,
  getApiExpertInsureHistoryList,
  getApiExpertInsureExport,
  getApiExpertInsureHistoryExport,
  postApiExpertInsure,
} from "@/api/tearcher";
import Insure from "./Insure.vue";
import InsureHistory from "./InsureHistory.vue";
export default {
  components: {
    Insure,
    InsureHistory,
  },
  data() {
    return {
      tabsList: ["学员", "班主任", "专家"], //tabs列表
      tabsActive: 0, //tabs活动索引
      elTabsActive: "1", //elTabs活动索引
      show: false, //是否显示
      //购买保险
      insure: {
        getApiList: "", //列表接口
        getApiExport: "", //导出接口
        postApiBuy: "", //购买接口
      },
      //保险历史
      insureHistory: {
        getApiList: "", //列表接口
        getApiExport: "", //导出接口
      },
    };
  },
  methods: {
    //tabs变更回调
    tabsChange(index) {
      this.show = false;
      this.tabsActive = index;
      this.elTabsActive = "1";
      this.module(index + 1);
    },
    //模块
    module(type) {
      //学员
      if (type == 1) {
        this.insure.getApiList = getApiInsureList;
        this.insureHistory.getApiList = getApiInsureHistoryList;
        this.insure.getApiExport = getApiInsureExport;
        this.insureHistory.getApiExport = getApiInsureHistoryExport;
        this.insure.postApiBuy = postApiInsure;
      }
      //班主任
      if (type == 2) {
        this.insure.getApiList = getApiHeadmasterInsureList;
        this.insureHistory.getApiList = getApiHeadmasterInsureHistoryList;
        this.insure.getApiExport = getApiHeadmasterInsureExport;
        this.insureHistory.getApiExport = getApiHeadmasterInsureHistoryExport;
        this.insure.postApiBuy = postApiHeadmasterInsure;
      }
      //专家
      if (type == 3) {
        this.insure.getApiList = getApiExpertInsureList;
        this.insureHistory.getApiList = getApiExpertInsureHistoryList;
        this.insure.getApiExport = getApiExpertInsureExport;
        this.insureHistory.getApiExport = getApiExpertInsureHistoryExport;
        this.insure.postApiBuy = postApiExpertInsure;
      }
      setTimeout(() => {
        this.show = true;
      }, 500);
    },
  },
  created() {
    this.module(1);
  },
};
</script>

<style lang="less" scoped></style>
